export default __webpack_public_path__ + "static/media/LocationFilled.da03ce4e.svg";